import { useCallback } from 'react';

import type { ITextInput } from '@/types';

type UpdateInput = (args: { id: string; value: Partial<ITextInput> }) => void;

const useTextInput = (updateInput: UpdateInput) => {
  const handleTextChange = useCallback(
    (id: string, value: string) => {
      updateInput({ id, value: { value } as Partial<ITextInput> });
    },
    [updateInput]
  );

  return { handleTextChange };
};

export default useTextInput;
